import PropTypes from "prop-types";
import React from "react";
import "../../../../../styles/ComponentsStyles/Operational/Academic/Events/EventsPreviewCard.style.css";
const EventsPreviewCard = ({ id = "", onClick }) => {
  return (
    <div className="w-full flex-col align-center justify-start p-1 back-white radius-6 g-1">
      <div className="flex-row align-center justify-start g-1">
        <div className="flex-row align-center justify-start g-05">
          <span className="t-16 poppins color-greenColor">Class:</span>
          <span className="t-16 poppins">5</span>
        </div>
        <div className="flex-row align-center justify-start g-05">
          <span className="t-16 poppins color-greenColor">Section:</span>
          <span className="t-16 poppins">A</span>
        </div>
      </div>

      <div
        className="w-full flex-col align-start justify-start back-mainContentBack overflow-hide p-05"
        style={{ height: "28vh" }}
      >
        <div
          className="w-full flex-col align-start justify-start back-mainContentBack overflow-hide p-05"
          style={{ height: "28vh" }}
        >
          <table className="eventstable">
            <thead>
              <tr>
                <th>Days</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
                <th>Subject & Time</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Monday</td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
                <td>
                  <div className="flex-col align-center justify-center">
                    <span>Bengali</span>
                    <span>10:30 AM - 11:30 AM</span>
                    <span>Sahid Afridi (SA)</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <button
        className="transparentCardBtn t-14 w-full pt-05 pb-05 radius-6 poppins color-white flex align-center justify-center"
        style={{
          background: "#67CABF",
          textDecoration: "none",
          borderBottom: "none",
        }}
        onClick={(e)=>onClick(e)}
      >
        View
      </button>
    </div>
  );
};

EventsPreviewCard.propTypes = {
  // board: PropTypes.string.isRequired,
  // affiliation: PropTypes.string.isRequired,
  // examMode: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  // path: PropTypes.string.isRequired,
};

// export default ProgramCard;
export default EventsPreviewCard;
